export default [
  {
    path: '/',
    name: 'default',
    redirect: '/login/auth',
  },
  {
    path: '/:catchAll(.*)',
    name: '404',
    redirect: '/',
  },
];
